<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Web Bot Logs</h5>
            </div>
            <div class="card">
                <div class="p-d-flex p-ai-center p-flex-column p-flex-lg-row p-mb-1">
                    <div class="p-d-flex p-mr-3">
                        <Dropdown v-model="emp_name" :options="adminList" @change="getWebBotLogs($event)"
                            optionLabel="label" appendTo="body" class="p-text-capitalize" placeholder="Select admin"
                            :style="{ minWidth: '200px' }" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <TabView v-if="userdatadisplayflag">
        <TabPanel header="Web Bot Log">
            <div class="card">
                <DataTable :value="webBotLogs" :lazy="true" :paginator="true" :rows="30" :totalRecords="webBotCount"
                    :loading="loading" @page="onPageChange" class="p-datatable-users" data-key="ad1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    :style="{ 'overflow-wrap': 'break-word' }">
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column header="Sr." headerStyle="width: 4%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column field="datetime" header="Date Time" headerStyle="width: 17%" bodyStyle="width: 17%">
                        <template #body="{ data }">
                            <div>{{ format_timestamp(data.lo2) }}</div>
                        </template>
                    </Column>
                    <Column field="Name" header="Name" headerStyle="width: 20%" bodyStyle="width: 20%">
                        <template #body="{ data }">
                            <div class="p-text-capitalize">
                                <div class="fw-bold">{{ data.lo12 ? data.lo12 : "N/A" }}</div>
                                <div>{{ data.lo13 ? data.lo13 : "N/A" }}</div>
                            </div>
                        </template>
                    </Column>
                    <Column field="message" header="Webbot Message" class="justify-content-between"
                        headerStyle="width: 50%" bodyStyle="width: 50%">
                        <template #body="{ data }">
                            <div>
                                <div style="max-width: 495px; word-wrap: break-word;"><span
                                        v-html="replacebrake(data.lo4)" v-if="data.lo4"></span></div>
                                <div v-if="data.lo16 != null && data.lo16 != ''">
                                    <img @click="whatsappimagepreview(data)" :src="data.lo16"
                                        style="vertical-align: middle; height:50px"
                                        class="whatsapp-Sent-image cursor-pointer whatsapp-imger-overlay" />
                                </div>
                            </div>
                        </template>
                    </Column>
                </DataTable>
                <Toast />
            </div>
        </TabPanel>
    </TabView>
</template>
<script>
import ApiService from '../../service/ApiService';
import moment from 'moment';

export default {
    data() {
        return {
            adminList: [],
            page_no: 0,
            webBotCount: 0,
            loading: false,
            webBotLogs: [],
            emp_name: '',
            userdatadisplayflag: false,
            admin_id: '',
            admin_list_status: false,
            itemsPerPage: 30,
            searchnamebtnactive: false,
            hidesearchname: false,
            searchfullname: '',
            searchnameloader: false,

        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    mounted() {
        this.storage_path = JSON.parse(localStorage.masterBucketName);
        if (this.$store.state.adminId != null) {
            this.admin_id = this.$store.state.adminId;
            let adminId = this.$store.state.adminId;
            this.ApiService.getAdminListOnly().then((data) => {
                if (data.status == 200) {
                    this.adminList = data.data.records;
                    let emp_name_id = data.data.records.filter(function (item) {
                        return item.value == adminId;
                    });
                    if (emp_name_id.length > 0) {
                        this.emp_name = emp_name_id[0];
                    }
                    this.getWebBotLogs();
                } else {
                    this.adminList = null;
                }
            });
        } else {
            this.getAdminListOnly();
        }
    },

    methods: {
        getAdminListOnly(e) {
            this.ApiService.getAdminListOnly(e).then((data) => {
                if (data.status == 200) {
                    this.adminList = data.data.records;
                    if (data.data.records.length == 1) {
                        this.getWebBotLogs({ value: data.data.records[0] });
                        this.emp_name = data.data.records[0];
                    }
                } else {
                    this.adminList = null;
                }
            });
        },
        getWebBotLogs(e) {
            this.userdatadisplayflag = true;
            this.loading = true;
            if (e) {
                this.admin_id = e.value.value;
            }
            this.ApiService.getWebBotLogs({ clientId: this.admin_id, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
                if (data.success === true) {
                    this.webBotLogs = data.data;
                    this.webBotCount = data.count;
                    this.loading = false;
                    this.admin_list_status = true;

                    this.searchnameloader = false;
                    // this.searchmobloader = false;
                    this.hidesearchname = false;
                    this.hidesearchmob = false;
                }
            });
        },
        onPageChange(e) {
            this.loading = true;
            if (this.admin_list_status) {
                this.page_no = e.page;
                this.getWebBotLogs();
            }
        },
        searchFnameVoter(searchfullname) {
            this.hidesearchname = true;
            this.searchnameloader = true;
            this.lr14 = searchfullname;
            this.getWebBotLogs({
                page_no: this.page_no,
                lr14: this.lr14,
            });
            this.searchnamebtnactive = true;
        },
        searchNameVoterStop() {
            this.searchnamebtnactive = false;
            this.searchfullname = "";
            this.getWebBotLogs({
                page_no: this.page_no,
            });
            this.searchnameloader = false;
        },
        format_timestamp(value) {
            if (value) {
                var localTime = new Date(value * 1000).toUTCString();
                return moment(localTime).format("DD/MM/YYYY @ hh:mm A");
            } else {
                return 'N/A';
            }
        },

        replacebrake(html) {
            const doc = html;
            return doc.replace(/(\r)*\n/g, '<br>');
        },
        decodeHtml(html) {
            return JSON.parse('"' + html + '"');
        },
    },
};
</script>
<style scoped lang="scss">
.custom-form-group {
    display: flex;
    align-items: center;
}
</style>
